import React, { MouseEventHandler } from 'react';
import c from 'classnames';
import Slider from '@wix/da-ds/pkg/Slider';
import { BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import SliderArrowButton from '../SliderArrowButton';
import s from './PanelSlider.scss';

interface Props {
  children: React.ReactNode;
  gradient?: 'primary' | 'secondary';
}

const PanelSlider: React.FC<Props> = ({ children, gradient = 'secondary' }) => {
  return (
    <div className={s['overflow-wrapper']}>
      <Slider
        className={s['slider']}
        permArrows
        onScrollBiData={{
          sectionname: BiContextProvidedValue,
        }}
        renderPrevButton={({ onClick, className: prevButtonClassName }) => (
          <div className={c(s['gradient-and-button'], s['left'], prevButtonClassName)}>
            <SliderArrowButton
              direction="left"
              onClick={
                onClick as MouseEventHandler<HTMLButtonElement> &
                  MouseEventHandler<HTMLAnchorElement>
              }
              className={s['arrow-button']}
            />
            <div
              role="presentation"
              className={c(
                s['gradient'],
                gradient === 'secondary' && s['gradient-secondary'],
                gradient === 'primary' && s['gradient-primary']
              )}
            />
          </div>
        )}
        renderNextButton={({ onClick, className: nextButtonClassName }) => (
          <div className={c(s['gradient-and-button'], s['right'], nextButtonClassName)}>
            <SliderArrowButton
              direction="right"
              onClick={
                onClick as MouseEventHandler<HTMLButtonElement> &
                  MouseEventHandler<HTMLAnchorElement>
              }
              className={s['arrow-button']}
            />
            <div role="presentation" className={s['gradient']} />
          </div>
        )}
      >
        {children}
      </Slider>
    </div>
  );
};

PanelSlider.displayName = 'PanelSlider';

export default PanelSlider;
